import React from 'react';
import { PencilSquareIcon } from '@heroicons/react/24/solid';
import { formatDate } from 'shared_items/formatConventions';

// ###### HELPERS
const formatValue = (v) => {
  if (v === null || v === undefined) return '—';
  const n = parseFloat(v);
  if (isNaN(n)) return '—';
  if (Math.abs(n) >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
  if (Math.abs(n) >= 1_000) return `${(n / 1_000).toFixed(1)}k`;
  return n.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

const OperationCard = ({ operation, style, onEditOperation }) => {
  const isBuy = operation?.operation_status === 'buy';
  const statusBadge = isBuy
    ? 'bg-emerald-100 text-emerald-800'
    : 'bg-rose-100 text-rose-800';

  return (
    <div
      style={style}
      className="border-b border-gray-100 hover:bg-gray-50/80 transition-colors duration-150 px-2 py-1.5 flex items-center gap-2"
    >
      {/* Left: edit + TAG */}
      <div className="flex items-center justify-center shrink-0 w-16 gap-0.5">
        {onEditOperation && (
          <button
            type="button"
            onClick={(e) => { e.stopPropagation(); onEditOperation(operation); }}
            className="p-1 rounded hover:bg-gray-200 text-gray-400 hover:text-gray-600 transition-colors flex-shrink-0"
            title="Editar"
          >
            <PencilSquareIcon className="h-4 w-4" />
          </button>
        )}
        <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${statusBadge}`}>
          {operation?.operation_status ?? '—'}
        </span>
      </div>
      {/* Center: date on top, then rest */}
      <div className="min-w-0 flex-1 flex flex-col gap-0.5">
        <div className="text-xs text-gray-500">
          {formatDate(operation?.operation_date, 'display')}
          {operation?.redeem_date && (
            <span className="ml-1">· redeem {formatDate(operation.redeem_date, 'display')}</span>
          )}
        </div>
        <div className="flex items-center gap-1.5 flex-wrap">
          <span className="text-sm font-medium text-gray-900 truncate">
            {operation?.asset_name ?? '—'}
          </span>
          <span className="text-xs font-mono text-gray-500 bg-gray-100 px-1 py-0.5 rounded shrink-0">
            {operation?.asset_code ?? '—'}
          </span>
          {(operation?.rate_description || operation?.notes) && (
            <span className="text-xs text-gray-400 truncate max-w-[140px]" title={operation.rate_description || operation.notes}>
              {operation.rate_description || operation.notes}
            </span>
          )}
        </div>
      </div>
      {/* Right: values */}
      <div className="flex flex-col items-end shrink-0 gap-0">
        <span className={`text-sm font-bold tabular-nums ${isBuy ? 'text-emerald-600' : 'text-rose-600'}`}>
          R$ {formatValue(operation?.total_value)}
        </span>
        {operation?.net_value != null && operation?.net_value !== operation?.total_value && (
          <span className="text-xs text-gray-500 tabular-nums">net R$ {formatValue(operation.net_value)}</span>
        )}
        {operation?.quantity != null && (
          <span className="text-xs text-gray-400 tabular-nums">qty {formatValue(operation.quantity)}</span>
        )}
      </div>
    </div>
  );
};

export default OperationCard;
